import React from 'react';
import { LinkStyled } from '../../components/typography';
import { getItemDefaultInformation } from '../../content/commerce/items';

export default ({ varenr }) => {
  const {
    url,
    name,
  } = getItemDefaultInformation(varenr);
  if (url) {
    return (
      <LinkStyled to={url}>
        {name}
      </LinkStyled>
    );
  }
  return name;
};
